export enum SvgIcons {
  'account-edit',
  'account-minus',
  'account-multiple',
  'account-plus',
  'add-location',
  'add-photo-alternate',
  'apps',
  'arrow-left',
  'attachment',
  'ballot',
  'bell',
  'calendar-check',
  'calendar-remove',
  'camera',
  'card-multiple',
  'circle-info-solid',
  'check-all',
  'check-circle',
  'check',
  'chevron-double-left',
  'chevron-double-right',
  'chevron-down',
  'chevron-left',
  'chevron-right',
  'chevron-up',
  'circle',
  'clipboard-check',
  'clipboard-clock',
  'clipboard-list',
  'clipboard-text',
  'close-circle',
  'close',
  'closed-caption',
  'cloud-download',
  'cloud-upload',
  'cog',
  'crop-square',
  'delete-forever',
  'dots-circle',
  'dots-horizontal',
  'download',
  'drag-indicator',
  'drive-file-rename',
  'email',
  'exclamation-thick',
  'file-document',
  'file-excel',
  'file-export',
  'file-pdf-box',
  'file-png-box',
  'file-word',
  'file',
  'filter',
  'floppy-disk-solid',
  'folder-zip',
  'format-list-checkbox',
  'format-list-numbered',
  'history',
  'hourglass-full',
  'inbox',
  'layers-triple',
  'lifebuoy',
  'location-off',
  'location-on',
  'lock-open-variant',
  'lock-open',
  'lock',
  'logout',
  'loop',
  'magnify',
  'map-marker-plus',
  'map-marker',
  'map',
  'menu-down',
  'menu-right',
  'menu',
  'message',
  'message-text',
  'minus-circle',
  'multiplication',
  'newspaper-variant',
  'playlist-plus',
  'plus',
  'question-answer',
  'refresh',
  'report',
  'send',
  'swap-horizontal',
  'text-snippet',
  'tune',
  'vector-square',
  'view-day',
  'view-list-outline',
  'warning',
  'zoom-in',
  'zoom-out'
}
